module.exports = __webpack_public_path__ + "static/media/maybay.985863a1.png";